export const SCREENS = {
    INTRO: 'INTRO',
    REG_1: 'REG_1',
    REG_2: 'REG_2',
    VIP_START: 'VIPSTART',
    LOGIN: 'LOGIN',
    LOBBY: 'LOBBY',
    START: 'START',
    START2: 'START2',
    GAME1: 'GAME1',
    GAME2: 'GAME2',
    GAME3: 'GAME3',
    GAME4: 'GAME4',
    FINAL_INTRO: 'FINALINTRO',
    FINAL_GAME: 'FINALGAME',
    PRE_FINISH: 'PREFINISH',
    PRIZES: 'PRIZES',
    FINISH: 'FINISH',
    PLUG: 'PLUG',
}

export const NEXT_SCREENS = {
    [SCREENS.REG_1]: SCREENS.REG_2,
    [SCREENS.REG_2]: SCREENS.START,
    [SCREENS.START]: SCREENS.START2,
    [SCREENS.START2]: SCREENS.LOBBY,
    [SCREENS.FINAL_INTRO]: SCREENS.FINAL_GAME,
    [SCREENS.FINAL_GAME]: SCREENS.PRE_FINISH,
    [SCREENS.PRE_FINISH]: SCREENS.PRIZES,
    [SCREENS.PRIZES]: SCREENS.FINISH,
}
